/*
 * @Description: 文件内容描述
 * @Author: 编辑人
 * @Date: 2021-08-02 09:28:50
 */
import Vue from "vue";

import Cookies from "js-cookie";
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";
import "./styles/commonStyle.scss";
import "@/assets/css/common.scss";

import "@/styles/index.scss"; // global css
import "@/assets/css/icons/iconfont.css";

import App from "./App";
import store from "./store";
import router from "./router";

// import i18n from "./lang"; // internationalization
import "./components/icons"; // icon
import "./permission"; // permission control

import * as filters from "./filters/index"; // global filters
import elTableInfiniteScroll from "el-table-infinite-scroll";
import infiniteScroll from "vue-infinite-scroll";
import screen from "@/components/BaseCom/screen";
import roleCheck from "@/utils/role-check";
import { SoftAlert, PushPage } from "./utils/message";
Vue.prototype.pushPage = PushPage;
Vue.prototype.softAlert = SoftAlert;
Vue.component("screen", screen);
import $validate from "./assets/js/validate";
Vue.prototype.$validate = $validate;
// var src = window.location.href; // 获取网页地址
// const tempIndex = src.indexOf("/", 7);
// const urls = src.substring(0, tempIndex);
// Vue.prototype.$fileUrl =
//     urls.indexOf("localhost") === -1 ? urls : process.env.VUE_APP_BASE_URL;
Vue.prototype.$fileUrl = process.env.VUE_APP_BASE_URL;

Vue.use(Element, {
    size: Cookies.get("size") || "medium" // set element-ui default size
        // i18n: (key, value) => i18n.t(key, value)
});

import { publicdownloadFile } from "@/assets/js/download";
import VueDND from 'awe-dnd';
// 注册-拖拽组件
Vue.use(VueDND);
Vue.prototype.$publicdownloadFile = publicdownloadFile
    // register global utility filters
Object.keys(filters.default).forEach(key => {
    Vue.filter(key, filters.default[key]);
});
Vue.prototype.$messages = function(msg) {
    this.$message({ message: msg, type: 'success', })
}
Vue.prototype.$messagee = function(msg) {
  // 失败提示
  this.$message.error({
    message: msg,
    duration: 3000,
    offset: 120,
    showClose: true,
  });
};
Vue.config.productionTip = false;
Vue.prototype.$roleCheck = roleCheck;
new Vue({
    el: "#app",
    router,
    store,
    // i18n,
    elTableInfiniteScroll,
    infiniteScroll,
    render: h => h(App)
});
